import CandidateDetailsPage from './CandidateDetailsPage';

export default CandidateDetailsPage;